import Vue from 'vue'
import { Button } from 'element-ui'
import { Pagination } from 'element-ui'
import { Input } from 'element-ui'
import { Form } from 'element-ui'
import { FormItem } from 'element-ui'
import { Checkbox } from 'element-ui'
import { checkboxGroup } from 'element-ui'
import { Message } from 'element-ui'

Vue.use(Button)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(checkboxGroup)
Vue.prototype.$message = Message;




